import { useContext, useEffect, useState } from 'react';
import { LovDTO, LovWithoutIdDTO, TruckTypeWithoutIdDTO } from '@api/ringil-api.v2';
import { ApiContext } from '../api/api';

export const useCountryRegion = () => {
  const [data, setData] = useState<LovDTO[]>([]);
  const { cuLoVCatalogRegions } = useContext(ApiContext);

  useEffect(() => {
    cuLoVCatalogRegions(d => setData(d));
  }, []);

  return data;
};

export const useImportExportCountries = () => {
  const [data, setData] = useState<LovWithoutIdDTO[]>([]);
  const { cuLoVCatalogCountries } = useContext(ApiContext);

  useEffect(() => {
    cuLoVCatalogCountries(d => setData(d));
  }, []);

  return data;
};

/**
 * Truck types, loaded once per session however many components ask for them.
 *
 * The list is a codebook — it does not change while the app is open — and several parts of a single
 * page want it at the same time (the truck-type tag, the merge panel). Without the cache each of
 * them fires its own request for the same answer.
 */
let truckTypesCache: TruckTypeWithoutIdDTO[] | null = null;
const truckTypesWaiting: ((data: TruckTypeWithoutIdDTO[]) => void)[] = [];
let truckTypesLoading = false;

export const useLovTruckTypes = () => {
  const [data, setData] = useState<TruckTypeWithoutIdDTO[]>(truckTypesCache ?? []);
  const { lovTruckTypes } = useContext(ApiContext);

  useEffect(() => {
    if (truckTypesCache) return;

    let cancelled = false;
    // Callers arriving while the first request is in flight wait for it rather than start another.
    truckTypesWaiting.push(loaded => !cancelled && setData(loaded));

    if (!truckTypesLoading) {
      truckTypesLoading = true;
      lovTruckTypes(loaded => {
        truckTypesCache = loaded;
        truckTypesLoading = false;
        truckTypesWaiting.splice(0).forEach(notify => notify(loaded));
      });
    }

    return () => {
      cancelled = true;
    };
  }, []);

  return data;
};
